import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { take } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { StatusModalComponent } from '@app/components/shared/status-modal/status-modal.component';
import { RoutePrefix } from '@app/utils/enums/route-prefix';
import { AppRoutes } from '@app/utils/enums/routes.enum';

@Component({
  selector: 'app-header-tabs',
  standalone: true,
  imports: [TranslatePipe, MatTabsModule, RouterModule],
  templateUrl: './header-tabs.component.html',
  styleUrl: './header-tabs.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderTabsComponent implements OnInit {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly dialog = inject(MatDialog);

  public routePrefix = RoutePrefix.USER_PROFILE;
  public appRoutes = AppRoutes;
  public RoutePrefix = RoutePrefix;
  public tabs: { route: string; label: string }[] = [];

  public ngOnInit(): void {
    this.router.events.pipe(take(1)).subscribe(() => {
      const path = this.route.snapshot.routeConfig?.path;
      this.routePrefix = path === 'settings' ? RoutePrefix.SHOP_SETTINGS : RoutePrefix.USER_PROFILE;

      this.setTabs();
    });
  }

  private setTabs(): void {
    this.tabs =
      this.routePrefix === RoutePrefix.USER_PROFILE
        ? [
            { route: this.appRoutes.PROFILE, label: 'user-profile.general.navigation.general' },
            {
              route: this.appRoutes.NOTIFICATIONS,
              label: 'user-profile.general.navigation.notifications',
            },
            {
              route: this.appRoutes.DATA_PRIVACY,
              label: 'user-profile.general.navigation.dataPrivacy',
            },
            { route: this.appRoutes.SECURITY, label: 'user-profile.general.navigation.security' },
            {
              route: this.appRoutes.ACTIVE_SESSIONS,
              label: 'user-profile.general.navigation.activeSessions',
            },
          ]
        : [
            {
              route: this.appRoutes.SETTINGS_GENERAL,
              label: 'shop-settings.general.navigation.general',
            },
            {
              route: this.appRoutes.CATEGORIES,
              label: 'shop-settings.general.navigation.categories',
            },
            { route: this.appRoutes.ROLES, label: 'shop-settings.general.navigation.roles' },
            { route: this.appRoutes.CONTENT, label: 'shop-settings.general.navigation.content' },
            {
              route: this.appRoutes.SUBSCRIPTION,
              label: 'shop-settings.general.navigation.subscription',
            },
          ];
  }

  public onSubscriptionTabClick(event: MouseEvent): void {
    if (navigator.onLine) {
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();

    this.dialog.open(StatusModalComponent, {
      data: {
        isSuccess: false,
        title: 'shop-settings.subscription.error.title',
        description: 'shop-settings.subscription.error.description',
      },
    });
  }
}
